import { IWorkStream } from "./WorkStream";
import { IReportingProgressUpdate, ReportingProgressUpdate } from "./ReportingProgressUpdate";

export interface IWorkStreamUpdate extends IReportingProgressUpdate {
    WorkStreamID: number | null;
    WorkStream?: IWorkStream;
}

export class WorkStreamUpdate extends ReportingProgressUpdate implements IWorkStreamUpdate {
    public WorkStreamID: number | null = null;

    constructor(workStreamId: number, period?: Date) {
        super(period);
        this.WorkStreamID = workStreamId;
    }
}